import { render, staticRenderFns } from "./EditBeneficiaryModal.vue?vue&type=template&id=387c5936"
import script from "./EditBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./EditBeneficiaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports